import Layout from '@/views/layout'

export default [
  {
    path: '/customer',
    name: 'customer',
    redirect: '/customer/workPlatform',
    component: Layout,
    meta: {
      title: '工作台',
      icon: 'workPlant.png',
      index: 4
    },
    children: [
      {
        path: 'workPlatform',
        name: 'workPlatform',
        meta: {
          title: '工作台',
          id: '1621476195'
        },
        component: () => import('@/views/customer/workPlatform')
      }
    ]
  }
]